import React, { useEffect } from 'react';
import ItemOptions from './item-options';
import { useQuery } from '@apollo/client';
import { QUERY_PRODUCT_NOTE } from '~/data/product/gql';
import { useParams } from 'next/navigation';
import { get } from 'lodash';

type Props = {
    data: Array<any>;
    onChange?: (dataChange: any) => void;
    onValidate?: (isValid: boolean) => void;
    error?: any;
    slug?: string;
    value?: {
        name: string;
        type: any;
        value: string;
    }[];
};

const CustomizationOptions = ({ onValidate, onChange, error, value, slug }: Props) => {
    const params = useParams();
    const { data: dataNote } = useQuery(QUERY_PRODUCT_NOTE, {
        variables: {
            param: slug ?? params?.slug
        }
    });
    const [dataChange, setDataChange] = React.useState<{
        options: string[];
        optionById: {
            [key: string]: {
                name: string;
                type: any;
                value: string;
                required: boolean;
                active: boolean;
                [key: string]: any;
            };
        };
    }>({
        options: [],
        optionById: {}
    });
    const firstRender = React.useRef(true);
    const handleOnchange = (data: { name: string; value: string }) => {
        // const index = dataChange?.options?.findIndex((item: any) => item.name === data.name);
        const tempOptionById = dataChange.optionById;
        if (!!tempOptionById[data.name]) {
            tempOptionById[data.name].value = data.value;
            const tempDataChange = dataChange;

            setDataChange((prev: any) => ({
                ...prev,
                optionById: {
                    ...prev.optionById,
                    ...tempOptionById
                }
            }));
        }
        firstRender.current = false;
    };

    const data: any[] = get(dataNote, 'products.items[0].product_note', []);

    useEffect(() => {
        if (data?.length > 0 && dataChange?.options?.length > 0) {
            const tempOptionById = dataChange.optionById;
            const isValid = dataChange?.options
                ?.filter((i: any) => {
                    return !!tempOptionById[i]?.required;
                })
                ?.every((item: any) => {
                    return !!tempOptionById[item] && !!tempOptionById[item]?.value;
                });

            onValidate && onValidate(isValid);
        }
    }, [dataChange?.optionById]);

    useEffect(() => {
        if (data?.length > 0) {
            const tempOptionById: any = {};
            const tempOptions: any = [];
            data.forEach((item: any) => {
                const _value = value?.find((i) => i.name === item.name);
                tempOptionById[item.name] = {
                    ...item,
                    value: _value?.value || ''
                };
                tempOptions.push(item.name);
            });
            const newData: any = {
                options: tempOptions,
                optionById: tempOptionById
            };
            setDataChange(newData);
        }
    }, [data, value]);
    useEffect(() => {
        onChange && onChange(dataChange);
    }, [dataChange]);

    return (
        <div className="mt-2">
            {data?.map((item, index: number) => {
                return (
                    <div key={index}>
                        <div className="flex">
                            <label className="mb-2 capitalize">
                                {item.label} {item.required ? <span className="text-red-500"> (*) </span> : ''}:
                            </label>
                        </div>
                        <ItemOptions
                            data={item}
                            onChange={handleOnchange}
                            value={dataChange.optionById[item.name]?.value}
                            error={error?.[item?.name]}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default CustomizationOptions;
